import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { HttpService } from '../http.service';
import { ApiService } from './api.service';
import { Values } from '@shared/entities/values';

const LOG_PREFIX = '[Api][Values] ';

@Injectable({
  providedIn: 'root'
})
export class ValuesService extends ApiService<Values> {
  constructor(private httpService: HttpService) {
    const masterUrl = '/values';
    const detailUrl = '/values';
    super(Values, masterUrl, detailUrl, undefined, 'values');
  }

  getValuesByKey(key?: string): Observable<Values> {
    this.logger.debug(LOG_PREFIX + 'getValuesByKey', { key });
    const url = `values?key=${key}`;
    return this.httpService.httpGet(url).pipe(
      map((response) => {
        this.logger.debug(LOG_PREFIX + 'getValuesByKey success', response);
        const values = response.values || {};

        return { id: response.id, values: values } as Values;
      }),
      catchError((error) => {
        this.logger.error(LOG_PREFIX + 'getValuesByKey error', error);
        return of({ id: '', values: [] } as Values);
      })
    );
  }

  getRoles(): Observable<Values> {
    return this.getValuesByKey('roles');
  }

  getMachineTypes(): Observable<Values> {
    return this.getValuesByKey('machineTypes');
  }
}
